export default from './StatsAccPerEnv.jsx';



// WEBPACK FOOTER //
// ./src/pages/stats_acc_per_env/index.js